import React from 'react';
import './switch.css';

/**
 * Switch
 */
const Switch = ({ id, value = false, onChange }) => {

  const toggle = () => {
    if (onChange) onChange(id, !value);
  }

  return (
    <label className="switch2">
      {value === true ? <input id={id} type="checkbox" checked onChange={toggle} /> : <input id={id} type="checkbox" onChange={toggle} />  }
      <span className="slider round" />
    </label>
  )
}

export default Switch;



// WEBPACK FOOTER //
// ./src/lib/components/switch.js